import React, { FC, ReactNode } from "react";
import { useMedia } from "react-use";

import { Header } from "@/components/Header";
import { Section } from "@/components/Section";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex } from "@/eworkitComponents/index";
import { Container } from "@/views/components/Container";

export interface IPageHeaderProps {
  header?: ReactNode;
}

export const PageHeader: FC<IPageHeaderProps> = ({ header, children }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <>
      {(children || (!isSmallScreen && header)) && (
        <Section background="background-card" shadow="default">
          <Container>
            <Flex align="center" justify="space-between" innerMargin="md">
              {!isSmallScreen && header && (
                <Flex>
                  <Header weight="bold">{header}</Header>
                </Flex>
              )}
              {header && <Flex grow={isSmallScreen ? 1 : 0}>{children}</Flex>}
              {!header && (
                <Flex grow={isSmallScreen ? 1 : 0} width={12}>
                  {children}
                </Flex>
              )}
            </Flex>
          </Container>
        </Section>
      )}
      {isSmallScreen && header && (
        <Flex padding={["lg", "md", false, "md"]}>
          <Header weight="bold">{header}</Header>
        </Flex>
      )}
    </>
  );
};
